import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { chapterShape, exerciseShape } from '../../../shapes/entities';

import ChapterSection from './chapter_section';
import Controls from '../../controls';
import ControlItem from '../../control_item';

import QuestionButton from './question_button';
import { correct } from '../../../containers/screens/exercise/utils';

const sum = (a, b) => a + b;
const achievableChapterScore = exercises =>
  exercises
    .map(exercise => exercise.attributes.achievable_score)
    .reduce(sum, 0);
const userChapterScore = exercises => {
  const score = exercises
    .map(exercise => exercise.attributes.user_score)
    .reduce(sum, 0);

  return score < 0 ? 0 : score;
};

const SolutionsGridScreen = ({
  chapters,
  onOpenResultsScreen,
  onExit,
  onOpenExerciseScreen,
  chapterExerciseMap
}) => {
  let count = 1;
  const chapterSections = chapters.map(chapter => {
    const exercises = chapterExerciseMap[chapter.id];
    if (exercises.length === 0) {
      return null;
    }
    const questionButtons = exercises.map(exercise => {
      const {
        relationships: { source }
      } = exercise;
      let isCorrect = null;
      let questionNumber = null;
      let numQuestions = 0;
      switch (source.data.type) {
        case 'questions':
          isCorrect = correct(exercise);
          questionNumber = count.toString();
          numQuestions = 1;
          break;
        case 'question_groups':
          numQuestions = exercise.attributes.answered.length;
          isCorrect =
            exercise.attributes.achievable_score ===
            exercise.attributes.user_score;
          questionNumber = `${count} - ${count + numQuestions - 1}`;
          break;
        default:
          isCorrect = correct(exercise);
      }
      count += numQuestions;
      return (
        <React.Fragment key={exercise.id}>
          <li>
            <QuestionButton
              questionNumber={questionNumber}
              correct={isCorrect}
              onClick={() => onOpenExerciseScreen(exercise)}
            />
          </li>
        </React.Fragment>
      );
    });
    return (
      <ChapterSection
        key={chapter.id}
        chapter={chapter}
        achievableScore={achievableChapterScore(exercises)}
        userScore={userChapterScore(exercises)}
      >
        <ul className="solutions-grid--questions">{questionButtons}</ul>
      </ChapterSection>
    );
  });

  return (
    <article>
      <h1 className="o-h1 t-margin-small--bottom">
        <FormattedMessage id="runs.show.solutions_grid.title" />
      </h1>
      <FormattedMessage id="runs.show.solutions_grid.description" tagName="p" />
      <div>{chapterSections}</div>

      <Controls>
        <ControlItem>
          <button
            type="button"
            className="o-button o-button--inverted l-width--16-of-16@small-only t-margin--bottom@small-only qa-results-button"
            onClick={onOpenResultsScreen}
          >
            <FormattedMessage id="runs.show.solutions_grid.back_to_results" />
          </button>
        </ControlItem>
        <ControlItem>
          <button
            type="button"
            className="o-button o-button--test-color l-width--16-of-16@small-only t-margin--bottom@small-only qa-exit-button"
            onClick={onExit}
          >
            <FormattedMessage id="runs.show.to_startpage" />
          </button>
        </ControlItem>
      </Controls>
    </article>
  );
};

SolutionsGridScreen.propTypes = {
  chapters: PropTypes.arrayOf(chapterShape).isRequired,
  chapterExerciseMap: PropTypes.objectOf(PropTypes.arrayOf(exerciseShape))
    .isRequired,
  onOpenResultsScreen: PropTypes.func.isRequired,
  onExit: PropTypes.func.isRequired,
  onOpenExerciseScreen: PropTypes.func.isRequired
};

export default SolutionsGridScreen;
